import { Component, inject } from '@angular/core';
import { ToastService, ToastType } from '../../services/toast/toast.service';

@Component({
  selector: 'app-toast-outlet',
  imports: [],
  templateUrl: './toast-outlet.html',
  styleUrl:    './toast-outlet.scss',
})
export class ToastOutlet {
  protected toastService = inject(ToastService);

  /** Material Symbol icon name per toast type. */
  iconFor(type: ToastType): string {
    const map: Record<ToastType, string> = {
      success: 'check_circle',
      error:   'error',
      warning: 'warning',
      info:    'info',
    };
    return map[type];
  }
}
